// The react-dnd item type shared between draggable dataset rows
// (dataset_table.tsx) and the drop targets in the folder tree
// (folder_tree.tsx). Lives in its own module to avoid a cyclic
// dependency between the two.
export const DraggableDatasetType = "DraggableDatasetRow";
